import { EMPTY_OBJECT } from '../../../constants/common'
import { DEFAULT_TIME_ZONE } from '../../../constants/date'
import { createNowDateInUkTimezone } from '../../../utils/date'
import { generateSentence } from '../../../utils/generate'
import { getTableVisibleColumns } from '../../Table'
import { TaskTableItemCommitType } from '../../Task'

const TITLE = generateSentence(10, 5)
const NOTES = generateSentence(7, 5)

const ACTIVITY_TYPE = {
  enabled: true,
  icon: {
    id: 0,
    name: 'call_1.svg',
  },
  id: 0,
  name: 'Call',
}

const COUNTERS = {
  active_automations: 0,
  error_messages: 0,
  files: 0,
  messages: 0,
  unread_messages: 0,
}

const SUCCESS_PHASE = {
  id: 0,
  name: 'success',
}

const MANAGER = {
  avatar: null,
  avatar_color: '#27AE7E',
  fullname: 'Main Admin',
  id: 0,
}

const USER = {
  avatar: null,
  avatar_color: '#DBC27F',
  fullname: 'Test user',
  id: 0,
}

const LOW_PRIORITY = {
  id: 0,
  value: 'low',
}

const SERVICE_REQUEST = {
  id: 0,
  request_no: 0,
  title: 'Test request',
}

const BUILDING = {
  id: 0,
  title: 'WG101 Theresiengasse 35, 1180 Wien, Austria',
}

const FLAT = {
  id: 0,
  number: '10',
}

const BUILDING_GROUPS = [
  {
    id: 1,
    name: 'test group',
  },
  {
    id: 2,
    name: 'test group 2',
  },
  {
    id: 3,
    name: 'test group 3',
  },
]

export const TABLE_ROW_COLUMNS_CONFIG = {
  activity_type: {
    index: 10,
    name: 'activity_type',
    ordering_field: null,
    title: 'ActivityTable.ActivityTypeColumnTitleKey',
    visible: true,
    width: 160,
  },
  building: {
    index: 5,
    name: 'building',
    ordering_field: 'building_title',
    title: 'ActivityTable.BuildingColumnTitleKey',
    visible: true,
    width: 416,
  },
  building_groups: {
    index: 7,
    name: 'building_groups',
    ordering_field: null,
    title: 'ActivityTable.BuildingGroupsColumnTitleKey',
    visible: true,
    width: 248,
  },
  closed_at: {
    index: 16,
    name: 'closed_at',
    ordering_field: 'closed_at',
    title: 'ActivityTable.ClosedAtColumnTitleKey',
    visible: true,
    width: 200,
  },
  closed_by: {
    index: 17,
    name: 'closed_by',
    ordering_field: 'closed_by',
    title: 'ActivityTable.ClosedByColumnTitleKey',
    visible: true,
    width: 240,
  },
  created: {
    index: 14,
    name: 'created',
    ordering_field: 'created',
    title: 'ActivityTable.CreatedColumnTitleKey',
    visible: true,
    width: 200,
  },
  created_by: {
    index: 15,
    name: 'created_by',
    ordering_field: 'created_by',
    title: 'ActivityTable.CreatedByColumnTitleKey',
    visible: true,
    width: 240,
  },
  deadline: {
    index: 3,
    name: 'deadline',
    ordering_field: 'deadline',
    title: 'ActivityTable.DeadlineColumnTitleKey',
    visible: true,
    width: 192,
  },
  flat: {
    index: 6,
    name: 'flat',
    ordering_field: 'flat',
    title: 'ActivityTable.FlatColumnTitleKey',
    visible: true,
    width: 184,
  },
  manager: {
    index: 2,
    name: 'manager',
    ordering_field: 'manager',
    title: 'ActivityTable.ManagerColumnTitleKey',
    visible: true,
    width: 240,
  },
  phase: {
    index: 9,
    name: 'phase',
    ordering_field: 'phase',
    title: 'ActivityTable.PhaseColumnTitleKey',
    visible: true,
    width: 336,
  },
  priority: {
    index: 8,
    name: 'priority',
    ordering_field: 'priority',
    title: 'ActivityTable.PriorityColumnTitleKey',
    visible: true,
    width: 176,
  },
  request: {
    index: 4,
    name: 'request',
    ordering_field: 'request',
    title: 'ActivityTable.RequestColumnTitleKey',
    visible: true,
    width: 448,
  },
  status: {
    index: 0,
    name: 'status',
    ordering_field: null,
    title: 'ActivityTable.StatusColumnTitleKey',
    visible: true,
    width: 150,
  },
  title: {
    index: 1,
    name: 'title',
    ordering_field: 'title',
    title: 'ActivityTable.TitleColumnTitleKey',
    visible: true,
    width: 528,
  },
  updated: {
    index: 12,
    name: 'updated',
    ordering_field: 'updated',
    title: 'ActivityTable.UpdatedColumnTitleKey',
    visible: true,
    width: 200,
  },
  updated_by: {
    index: 13,
    name: 'updated_by',
    ordering_field: 'updated_by',
    title: 'ActivityTable.UpdatedByColumnTitleKey',
    visible: true,
    width: 240,
  },
  visible_to_tenant: {
    index: 11,
    name: 'visible_to_tenant',
    ordering_field: null,
    title: 'ActivityTable.VisibleToTenantColumnTitleKey',
    visible: true,
    width: 56,
  },
}

export const TABLE_ROW_VISIBLE_COLUMNS = getTableVisibleColumns(
  TABLE_ROW_COLUMNS_CONFIG
)

export function getTableRowData(data) {
  const now = createNowDateInUkTimezone(DEFAULT_TIME_ZONE).toISOString()

  const {
    activity_type = ACTIVITY_TYPE,
    building = BUILDING,
    building_groups = BUILDING_GROUPS,
    closed_at = now,
    closed_by = USER,
    commit_type = TaskTableItemCommitType.Done,
    counters = COUNTERS,
    created = now,
    created_by = USER,
    deadline = now,
    done = false,
    flat = FLAT,
    id = 0,
    manager = MANAGER,
    notes = NOTES,
    phase = SUCCESS_PHASE,
    priority = LOW_PRIORITY,
    request = SERVICE_REQUEST,
    title = TITLE,
    updated = now,
    updated_by = USER,
    visible_to_tenant = false,
    yesno = null,
  } = data || EMPTY_OBJECT

  return {
    activity_type,
    building,
    building_groups,
    closed_at,
    closed_by,
    commit_type,
    counters,
    created,
    created_by,
    deadline,
    done,
    flat,
    id,
    manager,
    notes,
    phase,
    priority,
    request,
    title,
    updated,
    updated_by,
    visible_to_tenant,
    yesno,
  }
}
